module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-00-8ad89c624594f680d6806b16fbfc5ccf.svg";